/**
 * FitGapBadge — Small pill showing the Fit Gap value
 *
 * Displays "+12" in green or "-8" in orange with color coding
 * based on the fit label (strong-fit → mismatch).
 */

import React from 'react';
import { View, Text } from 'react-native';
import type { FitLabel } from '@/lib/thesis/types';
import { FIT_COLORS } from '@/lib/thesis/types';

interface FitGapBadgeProps {
  fitGap: number;
  fitLabel: FitLabel;
  size?: 'sm' | 'md' | 'lg';
}

const SIZE_STYLES = {
  sm: { px: 6, py: 2, fontSize: 10, lineHeight: 14 },
  md: { px: 8, py: 3, fontSize: 12, lineHeight: 16 },
  lg: { px: 10, py: 4, fontSize: 14, lineHeight: 18 },
} as const;

export function FitGapBadge({ fitGap, fitLabel, size = 'md' }: FitGapBadgeProps) {
  const color = FIT_COLORS[fitLabel];
  const s = SIZE_STYLES[size];
  const sign = fitGap > 0 ? '+' : '';

  return (
    <View
      style={{
        paddingHorizontal: s.px,
        paddingVertical: s.py,
        borderRadius: 999,
        backgroundColor: `${color}18`,
      }}
    >
      <Text
        style={{
          color,
          fontSize: s.fontSize,
          lineHeight: s.lineHeight,
          fontWeight: '700',
          fontVariant: ['tabular-nums'],
        }}
      >
        {sign}{fitGap}
      </Text>
    </View>
  );
}
